import { addErrorHandler, registerApplication, start } from 'single-spa'
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout'
import microfrontendLayout from './microfrontend-layout.html'
import { createBrowserHistory } from 'history'

const routes = constructRoutes(microfrontendLayout)
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name)
  },
})

const ErrorHandlerFn = (error) => {
  const history = createBrowserHistory()
  const current = location.pathname
  const menu = localStorage.getItem('menu')
  let navigationListError = []
  if (error.message.includes('LOADING_SOURCE_CODE')) {
    navigationListError = localStorage.getItem('navigationListError')
      ? localStorage.getItem('navigationListError').split(',')
      : []
    navigationListError.push(current)
    localStorage.setItem('navigationListError', navigationListError.join())
  }
  const errorIndex =
    menu.split(',').indexOf(current) >= menu.length
      ? -1
      : menu.split(',').indexOf(current)
  const list = localStorage.getItem('navigationList')
  if (
    list &&
    !(
      navigationListError.includes(list.split(',')[0]) &&
      navigationListError.includes(list.split(',')[1])
    )
  ) {
    history.push(
      list.split(',')[1] !== current ? list.split(',')[1] : list.split(',')[0],
      { snackbar: true },
    )
  } else {
    history.push(menu.split(',')[errorIndex + 1], { snackbar: true })
  }
}
const layoutEngine = constructLayoutEngine({ routes, applications })

applications.forEach(registerApplication)
layoutEngine.activate()
addErrorHandler(ErrorHandlerFn)
start()

export * from './utils/emitter'
